module.exports = __webpack_public_path__ + "static/great-ocean-road-gin-4b00bdaa1850ccff2c3440be3e2b13a6.jpg";